/**
 * Directive: cellInput
 */
angular.module('acme.common.directive.cellInput', [])
.directive('cellInput', [function() {
  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ngModel) {
      var oldCellValue;
      var dereg = scope.$watch('ngModel', function() {
        oldCellValue = ngModel.$modelValue;
        dereg();
      });

      function keydown (evt) {
        switch (evt.keyCode) {
          case 37:
          case 38:
          case 39:
          case 40:
            evt.stopPropagation();
            break;
          case 27:
            if (!scope.$$phase) {
              scope.$apply(function() {
                ngModel.$setViewValue(oldCellValue);
                elm.blur();
              });
            }
            break;
          case 13:
            if(scope.enableCellEditOnFocus && scope.totalFilteredItemsLength() - 1 > scope.row.rowIndex && scope.row.rowIndex > 0  || scope.col.enableCellEdit) {
              elm.blur();
            }
            break;
        }

        return true;
      }
      elm.bind('keydown', keydown);

      function click (evt) {
        evt.stopPropagation();
      }

      elm.bind('click', click);

      function mousedown (evt) {
        evt.stopPropagation();
      }

      elm.bind('mousedown', mousedown);

      elm.on('$destroy', function() {
        elm.off('keydown', keydown);
        elm.off('click', click);
        elm.off('mousedown', mousedown);
      });

      scope.$on('$destroy', scope.$on('ngGridEventStartCellEdit', function () {
        if (attrs.cellInput === 'multiSelect') {
          scope.$emit('cellInputEditStart::modal', { rowIndex: scope.row.rowIndex, column: scope.col });
        }
        elm.focus();
        elm.select();
      }));

      angular.element(elm).bind('blur', function () {
        scope.$emit('cellInputEdit', { rowIndex: scope.row.rowIndex, column: scope.col });
        scope.$emit('ngGridEventEndCellEdit');
      });
    }
  };
}]);